import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WorkOrderList } from './work-order-list/work-order-list';
import NOB from '../../../constants/language-strings';
import { EmptyState } from 'components/InfoBox/empty-state';
import styled from 'styled-components';
import spacing from 'theme/spacing';
const WorkOrderListContent = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
const WorkOrderListComplete = styled.div `
  width: 100%;
  max-width: 640px;
  min-width: 320px;
`;
const WorkOrderListCompleteHeading = styled.span `
  margin-left: ${spacing.spacing4};
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
`;
export const SlideContent = ({ isWorkOrderListEmpty = false, areAllWorkOrdersDone = false, isTechnician = false, isExternalInstaller = false, workOrdersCancelled = [], workOrdersDone = [], workOrdersNotDone, }) => (_jsxs(WorkOrderListContent, { children: [workOrdersNotDone.length > 0 && _jsx(WorkOrderList, { workOrders: workOrdersNotDone }), areAllWorkOrdersDone && isExternalInstaller && (_jsx(EmptyState, { title: NOB.NO_WORK_ORDERS.DONE })), isWorkOrderListEmpty && isTechnician && (_jsx(EmptyState, { title: NOB.NO_WORK_ORDERS.NO_WORK_ORDERS, text: NOB.NO_WORK_ORDERS.WAIT_FOR_NEXT })), workOrdersDone.length > 0 && (_jsxs(WorkOrderListComplete, { children: [_jsxs(WorkOrderListCompleteHeading, { children: [NOB.WORKORDER_LIST.COMPLETED_HEADER, " al"] }), _jsx(WorkOrderList, { workOrders: workOrdersDone })] })), workOrdersCancelled.length > 0 && (_jsxs(WorkOrderListComplete, { children: [_jsx(WorkOrderListCompleteHeading, { children: NOB.WORKORDER_LIST.CANCELLED_JOBS }), _jsx(WorkOrderList, { workOrders: workOrdersCancelled })] })), isWorkOrderListEmpty && isExternalInstaller && (_jsx(EmptyState, { title: NOB.FEEDBACKS.HMM, text: NOB.NO_WORK_ORDERS.NO_WORK_ORDERS }))] }));
